import { useAuth } from '../../hooks/useAuth'
import { Navigate } from 'react-router-dom'
import ErrorMessage from '../Common/ErrorMessage'

const PermissionWrapper = ({
    children,
    requiredPermission,
    requiredAction = 'read',
    fallbackPath = '/admin/dashboard',
    showError = true
}) => {
    const { user } = useAuth()

    // Helper function to check if user has permission for a section
    const hasPermission = (section, action = 'read') => {
        if (!user || !user.permissions) return false
        if (user.role === 'admin') return true // Admin has all permissions
        return user.permissions[section] && user.permissions[section][action]
    }

    // Check if user has the required permission
    if (!hasPermission(requiredPermission, requiredAction)) {
        if (showError) {
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <ErrorMessage
                        message={`Access Denied: You don't have permission to access this section. Required: ${requiredPermission} - ${requiredAction}`}
                        showRetry={false}
                    />
                </div>
            )
        } else {
            return <Navigate to={fallbackPath} replace />
        }
    }

    return children
}

export default PermissionWrapper
